import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d09ea98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "confirmButton",
  class: "btn-confirm-wrap"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmButton',
  props: {
  context: {
    type: String,
    required: false,
  },
},
  emits: ['onClick_confirm', 'onClick_cancel'],
  setup(__props, { emit }) {

const props = __props;



/**** content -----------------
 *
 * 취소 / 확인 버튼
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-type-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_cancel')))
    }, "취소"),
    _createElementVNode("button", {
      class: "btn btn-type-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClick_confirm')))
    }, "확인")
  ]))
}
}

})